import { render, staticRenderFns } from "./list_text.vue?vue&type=template&id=6d22f176&scoped=true"
import script from "./list_text.vue?vue&type=script&lang=js"
export * from "./list_text.vue?vue&type=script&lang=js"
import style0 from "./list_text.vue?vue&type=style&index=0&id=6d22f176&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d22f176",
  null
  
)

export default component.exports